import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import _ from 'lodash';

import getLicencias from '../../../graphql/querys/rrhh/getLicencias.graphql';
import TablaLicencias from './TablaLicencias';
import deleteLicencia from '../../../graphql/mutations/rrhh/deleteLicencia.graphql';
import reenviarMailLicencia from '../../../graphql/mutations/rrhh/reenviarMailLicencia.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

import getLicenciasConFiltros from '../../../graphql/querys/rrhh/getLicenciasConFiltros.graphql';
import getCantidadLicenciasPorFiltros from '../../../graphql/querys/rrhh/getCantidadLicenciasPorFiltros.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(deleteLicencia, {
    name: 'deleteLicencia',
    options: {
      refetchQueries: [{ query: getLicencias }],
    },
  }),
  graphql(reenviarMailLicencia, {
    name: 'reenviarMailLicencia',
  }),
  graphql(getOrganismos)
)
class VerLicencias extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      filtroNombre: null,
      filtroApellido: null,
      filtroOrganismo: null,
      filtroEstado: null,
      pagina: 1,
      cantidadPorPagina: 10,
      idOrganismo: null,
      reenviarEmailLoading: false,
    };
  }

  componentDidMount() {
    this.buscarCantidadLicencias();
  }

  buscarCantidadLicencias = () => {
    this.props.client
      .query({
        query: getCantidadLicenciasPorFiltros,
        variables: {
          filtros: {
            nombreSolicitante: this.state.filtroNombre,
            apellidoSolicitante: this.state.filtroApellido,
            idOrganismo: this.state.filtroOrganismo,
            estado: this.state.filtroEstado,
          },
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        this.setState(
          {
            cantidadTotal: res.data.getCantidadLicenciasPorFiltros,
          },
          () => {
            this.lanzarconsulta();
          }
        );
      })
      .catch(err => {
        console.log(
          'error a la hora de buscar la cantidad total de paginas en licencias'
        );
        console.log(err);
        errorService(err, {
          filtros: {},
        });
      });
  };

  lanzarconsulta = () => {
    this.setState({
      loadingTabla: true,
      loading: true,
    });
    this.props.client
      .query({
        query: getLicenciasConFiltros,
        variables: {
          filtros: {
            nombreSolicitante: this.state.filtroNombre,
            apellidoSolicitante: this.state.filtroApellido,
            idOrganismo: this.state.filtroOrganismo,
            estado: this.state.filtroEstado,
          },
          pagina: this.state.pagina,
          cantidadPorPagina: this.state.cantidadPorPagina,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getLicenciasConFiltros) {
          this.setState(
            {
              listaFiltrada: res.data.getLicenciasConFiltros,
              loadingTabla: false,
              loading: false,
            },
            () => {
              this.ordenarLista(
                this.state.pagina,
                this.state.cantidadPorPagina
              );
            }
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        notification.error({
          message: 'Error a la hora de buscar las licencias',
        });
        this.setState({
          loadingTabla: false,
          loading: false,
        });
      });
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroNombre: filtro,
        loading: true,
      },
      () => this.buscarCantidadLicencias()
    );
  };

  setFiltrarPorAPyN = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroNombre: filtro.nombreSolicitante,
        filtroApellido: filtro.apellidoSolicitante,
        loading: true,
      },
      () => this.buscarCantidadLicencias()
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroApellido: filtro,
        loading: true,
      },
      () => this.buscarCantidadLicencias()
    );
  };

  filtrarPorOrganismo = async idOrganismo => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroOrganismo: idOrganismo,
        loading: true,
      },
      () => this.buscarCantidadLicencias()
    );
  };

  filtrarPorEstado = async estado => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroEstado: estado,
        loading: true,
      },
      () => this.buscarCantidadLicencias()
    );
  };

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (nextProps.data.getLicencias) {
  //     this.setState(
  //       {
  //         ...this.state,
  //         listaTotal: nextProps.data.getLicencias,
  //       },
  //       function() {
  //         this.ordenarLista(1, 20);
  //       }
  //     );
  //   }
  // }

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaFiltrada,
      [
        licencia => {
          // return licencia.solicitante.nombre.toUpperCase();
          return licencia.fechaInicio;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      lista: listaOrdenada,
    });
  };

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta licencia?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteLicencia({
            variables: { _id: id },
          })
          .then(res => {
            // console.log("La respuesta del delete fue....");
            // console.log(res);

            let id = res.data.deleteLicencia;

            if (id) {
              notification.warning({
                message: 'Licencia eliminada',
                description: 'Se ha eliminado la licencia exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar la licencia');
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion de la licencia ',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  onReenviarEmail = id => {
    this.setState({ reenviarEmailLoading: true });
    this.props
      .reenviarMailLicencia({
        variables: { _id: id },
      })
      .then(res => {
        if (res.data.reenviarMailLicencia) {
          notification.success({
            message: 'Email reenviado',
            description: 'El email ha sido reenviado exitosamente',
          });
          this.lanzarconsulta();
        }
      })
      .catch(err => {
        console.log('Error al reenviar el email de la licencia');
        console.log(err);

        Modal.error({
          title: 'Error al reenviar el email',
          content:
            'No se pudo reenviar el email. Si el error persiste, comuníquese con el departamento de informática.',
        });
      })
      .finally(() => {
        this.setState({ reenviarEmailLoading: false });
      });
  };

  render() {
    return (
      <div>
        <TablaLicencias
          licencias={this.state.lista}
          usuario={this.props.usuario}
          history={this.props.history}
          onDelete={this.onDelete}
          onReenviarEmail={this.onReenviarEmail}
          reenviarEmailLoading={this.state.reenviarEmailLoading}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorApellido={this.filtrarPorApellido}
          setFiltrarPorAPyN={this.setFiltrarPorAPyN}
          setFiltrarOrganismo={this.filtrarPorOrganismo}
          setFiltrarEstado={this.filtrarPorEstado}
          filtroNombrePadre={this.state.filtroNombre}
          filtroApellidoPadre={this.state.filtroApellido}
          filtroOrganismoPadre={this.state.filtroOrganismo}
          listaOrganismos={this.props.data ? this.props.data.getOrganismos : []}
          filtroEstadoPadre={this.state.filtroEstado}
          cambiarPagina={this.cambiarPagina}
          tamPagina={this.state.cantidadPorPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          loadingTabla={this.state.loading}
          pagina={this.state.pagina}
        />
      </div>
    );
  }
}

export default withApollo(VerLicencias);
